import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";

const FetchVeridionKpiAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplierdiscovery/kpi_page_data_vr`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_VERIDION_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}

export { FetchVeridionKpiAction }